
export class InvoicePaymentGatewayLog {

    ID: number;
    Gateway: string;
    DateTime: Date;
    Description: string;
    AmountIn: number;
    AmountOut: number;
    TransactionID: string;
    RefundID: number;

    static FixDate(item: InvoicePaymentGatewayLog) {
        item.DateTime = new Date(item.DateTime);
    }

}

export class InvoicePaymentGatewayLogArray extends Array<InvoicePaymentGatewayLog>  {

    constructor(...items: InvoicePaymentGatewayLog[]) {
        super(...items);
        Object.setPrototypeOf(this, InvoicePaymentGatewayLogArray.prototype);
    }

    static FixDates(items: InvoicePaymentGatewayLogArray) {
        items.forEach(x => InvoicePaymentGatewayLog.FixDate(x));
    }

}
